import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

const AppLeftNavContent = () =>
  import(/* webpackChunkName: "4-feat-mobile-nav-overlay" */ './AppLeftNavContent').then((m) => ({
    default: m.AppLeftNavContent,
  }));

const LoadableAppLeftNav: ComponentType = lazyLoadOnRender({ loader: AppLeftNavContent });
export default LoadableAppLeftNav;
